module.exports = __webpack_public_path__ + "static/media/card4_1.5353d014.png";